import { buildModelManager } from "../builder.js";
const DefaultScenarioGenerationProgressSelection = {
  __typename: true,
  id: true,
  completedAt: true,
  completedElements: true,
  createdAt: true,
  currentMessage: true,
  errorMessage: true,
  formData: true,
  generatedScenario: true,
  progressEvents: true,
  sessionId: true,
  startedAt: true,
  status: true,
  updatedAt: true,
  userId: true
};
const modelApiIdentifier = "scenarioGenerationProgress";
const pluralModelApiIdentifier = "scenarioGenerationProgresses";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindBySessionId",
    findByField: "sessionId",
    findByVariableName: "sessionId",
    modelApiIdentifier,
    defaultSelection: DefaultScenarioGenerationProgressSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createScenarioGenerationProgress",
    operationReturnType: "CreateScenarioGenerationProgress",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      scenarioGenerationProgress: {
        required: false,
        type: "CreateScenarioGenerationProgressInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "action",
    operationName: "bulkCreateScenarioGenerationProgresses",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateScenarioGenerationProgressesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "action",
    operationName: "updateScenarioGenerationProgress",
    operationReturnType: "UpdateScenarioGenerationProgress",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      scenarioGenerationProgress: {
        required: false,
        type: "UpdateScenarioGenerationProgressInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateScenarioGenerationProgresses",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateScenarioGenerationProgressesInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "action",
    operationName: "deleteScenarioGenerationProgress",
    operationReturnType: "DeleteScenarioGenerationProgress",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteScenarioGenerationProgresses",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertScenarioGenerationProgress",
    operationReturnType: "UpsertScenarioGenerationProgress",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      scenarioGenerationProgress: {
        required: false,
        type: "UpsertScenarioGenerationProgressInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateScenarioGenerationProgressResult": { hasReturnType: false },
      "... on UpdateScenarioGenerationProgressResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertScenarioGenerationProgresses",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertScenarioGenerationProgressesInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultScenarioGenerationProgressSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "scenarioGenerationProgressGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const ScenarioGenerationProgressManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultScenarioGenerationProgressSelection,
  operations
);
export {
  DefaultScenarioGenerationProgressSelection,
  ScenarioGenerationProgressManager
};
//# sourceMappingURL=ScenarioGenerationProgress.js.map
